import { render, staticRenderFns } from "./ClienteLocacoesTab.vue?vue&type=template&id=d79138f0&"
import script from "./ClienteLocacoesTab.vue?vue&type=script&lang=js&"
export * from "./ClienteLocacoesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports